import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import "./index.css";
import HomePage from "./pages/home/HomePage";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import store from "./store";
import Base64EncodePage from "pages/base64Encode/Base64EncodePage";
import Base64DecodePage from "pages/base64Decode/Base64DecodePage";
import Base64Page from "pages/base64/Base64Page";
import Md5HashPage from "pages/md5Hash/Md5HashPage";
import UrlEncodePage from "pages/urlEncode/UrlEncodePage";
import UrlDecodePage from "pages/urlDecode/UrlDecodePage";
import UrlPage from "pages/url/UrlPage";
import GuidGeneratePage from "pages/guidGenerate/GuidGeneratePage";
import PrivacyPolicyPage from "pages/privacyPolicy/PrivacyPolicyPage";
import ContactPage from "pages/contact/ContactPage";
import TermsAndConditionsPage from "pages/termsAndConditions/TermsAndConditionsPage";
import NotFoundPage from "pages/notFound/NotFoundPage";

const rootElement = document.getElementById("root") as HTMLElement;

const appContent = (
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route index element={<HomePage />} />
          <Route path="base64" element={<Base64Page />} />
          <Route path="base64encode" element={<Base64EncodePage />} />
          <Route path="base64decode" element={<Base64DecodePage />} />
          <Route path="md5hash" element={<Md5HashPage />} />
          <Route path="url" element={<UrlPage />} />
          <Route path="urlencode" element={<UrlEncodePage />} />
          <Route path="urldecode" element={<UrlDecodePage />} />
          <Route path="guidgenerate" element={<GuidGeneratePage />} />
          <Route path="privacypolicy" element={<PrivacyPolicyPage />} />
          <Route
            path="termsandconditions"
            element={<TermsAndConditionsPage />}
          />
          <Route path="contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);

// Render normally - SEO handled by pre-rendered HTML
const root = ReactDOM.createRoot(rootElement);
root.render(appContent);

reportWebVitals();
